import React from 'react'
import { Box } from '@mui/material';
import { makeStyles } from '@material-ui/core';

const useStyle = makeStyles(theme => {
    return {
        container: {
            display: 'flex',
            alignItems: 'flex-start',
            flexDirection: 'column',
            marginTop: 20,
            marginBottom: 50,
            maxWidth: 800,
            margin: 'auto',
        },
    }
});

const ContentContainer = ({ children }) => {
    const classes = useStyle();
    return (
        <Box className={classes.container}>
            {children}
        </Box>
    )
}

export default ContentContainer;